import React from 'react';

import './BrandLogo.scss';
import { LoadingIndicator } from '@spark-labs/avocado-ui/dist/components/LoadingIndicator';
import { Link } from 'react-router-dom';

interface BrandLogoPropsBase {
  logo?: string;
  bgColor?: string;
  imgClassName?: string;
}

type BrandLogoProps = React.HTMLAttributes<HTMLDivElement> & BrandLogoPropsBase;

/**
 * Loads the brand logo async, it maintains aspect ratio
 * and height, so the app has more UI consistency
 *
 * @param plan plan which contains the property
 */
export function BrandLogo(props: BrandLogoProps) {
  const {
    logo,
    bgColor = 'bg-white',
    className: propClasses,
    imgClassName: propImgClasses,
    ...rest
  } = props;

  const classes = ['brand-logo-wrapper', bgColor];
  if (propClasses) classes.push(propClasses);

  const imgClasses = [];
  if (propImgClasses) imgClasses.push(propImgClasses);

  return (
    <Link to="/" style={{ lineHeight: 0 }}>
      <div {...rest} className={classes.join(' ')}>
        {logo ? (
          <img src={logo} className={imgClasses.join(' ')} />
        ) : (
          <LoadingIndicator size="small" />
        )}
      </div>
    </Link>
  );
}
